module.exports = __webpack_public_path__ + "static/media/shuri-atomi-lesb.11bd1edc.jpg";